<template>
  <div class="main-content">
    <div class="section__content section__content--p30 m-b-30">
      <div class="container-fluid">
        <div class="overview-wrap m-b-35">
          <h2 class="title-1">
            <i class="fas fa-video p-r-10" style="padding-left: 7px;"></i>
            {{ text('recordings_header') }} ({{ recordings.length }})
          </h2>
          <v-btn color="success" @click="newRecord()">
            <i class="zmdi zmdi-plus p-r-10"></i>{{ text('add_new_record_btn') }}
          </v-btn>
        </div>
        <v-card class="p-b-10 p-t-10 p-l-30 p-r-30 m-b-30 m-r-5">
          <div class="el-loading-mask" v-if="loading">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg>
            </div>
          </div>
          <div class="row">
            <div class="table-responsive table-hover live-jobs">
              <table class="align-middle table">
                <thead>
                <tr>
                  <th></th>
                  <th>{{ text('name') }}</th>
                  <th></th>
                  <th>{{ text('record_period') }}</th>
                  <th>{{ text('channel') }}</th>
                  <th>{{ text('status') }}</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="!loading && !recordings.length" class="no-rows">
                  <td colspan="7" class="text-center">
                    <div class="m-b-15 m-t-15">
                      {{ text('no_records_text') }}
                    </div>
                  </td>
                </tr>
                <tr v-for="(record, i) of recordings"
                    :key="record.id"
                    @mouseover="setActiveRow(i)"
                    @mouseleave="setActiveRow(-1)">
                  <td @click="showDetail(record)" style="width: 80px;">
                    <i class="zmdi zmdi-dot-circle red--text" style="font-size: 20px;"
                       v-if="record.state === 'ok'"></i>
                    <i class="zmdi zmdi-pause-circle" style="font-size: 20px;"
                       v-else></i>
                  </td>
                  <td @click="showDetail(record)">
                    {{ record.name }}
                  </td>
                  <td @click="showDetail(record)" style="width: 30px;">
                    <i class="fa fa-calendar grey--text p-l-10" style="font-size: 18px;"></i>
                  </td>
                  <td @click="showDetail(record)">
                    {{ recordPeriod(record.duration) }}
                  </td>
                  <td @click="showDetail(record)">
                    <span v-if="!record.channelName" class="spinner-border spinner-grow-sm"></span>
                    <span v-else>{{ record.channelName }}</span>
                  </td>
                  <td @click="showDetail(record)">
                    <span class="text-uppercase blocked-text lighten-4"
                          :class="{'green': record.state === 'ok', 'red': record.state === 'error'}">
                      {{ record.state }}
                    </span>
                  </td>
                  <td class="text-right" style="width: 80px;">
                    <v-btn
                      text
                      icon
                      :class="{'error--text': activeRow === i}"
                      @click.stop="openDeleteDialog(record)">
                      <i class="fa fa-trash-alt grey--text" style="font-size: 18px;"></i>
                    </v-btn>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </v-card>

      </div>
    </div>

    <!-- Remove Dialog -->
    <v-dialog v-model="removeDialog" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline">
          Delete DVR record?
        </v-card-title>
        <v-card-text>
          <div class="row p-b-20">
            <div class="col-md-12">
              Are you sure you want to delete the DVR record "{{ deletedRecord.name }}"?
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed small text
                 @click="removeDialog = false">No</v-btn>
          <v-btn depressed small color="error"
                 @click="deleteRecord()">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { processDVRChannel } from '@/store/converters';

export default {
  created() {
    this.loadData();
  },
  data() {
    return {
      recordings: [],
      removeDialog: false,
      deletedRecord: {},
      activeRow: -1,
    };
  },
  computed: {
    loading() {
      return this.$store.getters.isDataLoaded;
    },
    dict() {
      return this.$store.getters.dictionary;
    },
  },
  methods: {
    newRecord() {
      this.$router.push({
        name: 'DVRNewPage',
      });
    },
    loadData() {
      this.$store.commit('setPageLoader');
      this.$store.dispatch('dvr/getDVRChannels')
        .then((result) => {
          this.recordings = result.map(dc => processDVRChannel(dc));
          this.findChannelNames();
        })
        .catch((errorMsg) => {
          this.$toasted.error(errorMsg, {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 10000,
          });
        })
        .finally(() => this.$store.commit('resolvePageLoader'));
    },
    showDetail(record) {
      this.$router.push({
        name: 'DVRDetailPage',
        params: {
          id: record.id,
        },
      });
    },
    recordPeriod(sec) {
      const duration = moment.duration(sec * 1000);
      let days = Math.floor(duration.asDays());
      if (days < 1) {
        days = 0;
        return `${duration.hours()}h`;
      }
      duration.subtract(moment.duration(days, 'days'));
      const hours = duration.hours();
      return `${days}d ${hours}h`;
    },
    setActiveRow(i) {
      this.activeRow = i;
    },
    openDeleteDialog(record) {
      this.deletedRecord = Vue.util.extend({}, record);
      this.removeDialog = true;
    },
    deleteRecord() {
      if (!this.deletedRecord.id) return;
      this.$store.dispatch('dvr/removeDVRChannel', this.deletedRecord.id)
        .then(() => {
          this.$toasted.success('The DVR record has been successfully removed', {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 5000,
          });
          this.loadData();
          this.deletedRecord = {};
          this.removeDialog = false;
        })
        .catch((errorMsg) => {
          this.removeDialog = false;
          this.$toasted.error(errorMsg, {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 7000,
          });
        });
    },
    findChannelNames() {
      const args = {
        limit: 500,
        offset: 0,
      };
      const recordMap = {};
      for (let i = 0; i < this.recordings.length; i += 1) {
        const parts = this.recordings[i].inputURL.split('?hls.variants=');
        recordMap[parts[0]] = i;
      }
      this.$store.dispatch('jobs/getLiveJobs', args)
        .then((jobs) => {
          for (let i = 0; i < jobs.length; i += 1) {
            const job = jobs[i];
            for (let j = 0; j < job.outputs.length; j += 1) {
              const output = job.outputs[j];
              if (output.format === 'segmented_hls' && output.url.length > 0) {
                // eslint-disable-next-line no-prototype-builtins
                if (recordMap.hasOwnProperty(this.processURL(output.url[0]))) {
                  const key = recordMap[this.processURL(output.url[0])];
                  const updated = this.recordings[key];
                  updated.channelName = job.name;
                  Vue.set(this.recordings, key, updated);
                }
              }
            }
          }
          for (let i = 0; i < this.recordings.length; i += 1) {
            if (!this.recordings[i].channelName) {
              this.recordings[i].channelName = 'N/A';
            }
          }
        })
        .catch((errorMsg) => {
          console.log(errorMsg);
        });
    },
    processURL(url) {
      if (url.startsWith('origin')) {
        return url.replace('origin', 'http');
      }
      return url;
    },
    text(code) {
      // eslint-disable-next-line no-prototype-builtins
      if (this.dict.hasOwnProperty(code)) {
        return this.dict[code];
      }
      return code;
    },
  },
};
</script>
